export default class ServicoService {

  constructor(resource) {
      this.clipping = resource('block/servicos');
  }

  servicos() {
    return this.clipping
      .query()
      .then( res =>  {
        return res.json();
      }, err => {
        throw new Error('Não foi possível obter a lista de clientes.');
      });
  }
}



// WEBPACK FOOTER //
// ./src/domain/ServicoService.js